import { NgModule } from '@angular/core';
import { RsCountUpDirective } from './rs-count-up.directive';
import { RsParallaxDirective } from './rs-parallax.directive';
import { RsRevealDirective } from './rs-reveal.directive';
import { RsRippleDirective } from './rs-ripple.directive';
import { RsServiceTimelineDirective } from './rs-service-timeline.directive';

const DIRECTIVES = [
  RsRevealDirective,
  RsRippleDirective,
  RsCountUpDirective,
  RsParallaxDirective,
  RsServiceTimelineDirective,
] as const;

/**
 * Convenience bundle of the design-system motion directives.
 * Import into any NgModule, or import the directives directly in a standalone
 * component — they are all standalone.
 */
@NgModule({
  imports: [...DIRECTIVES],
  exports: [...DIRECTIVES],
})
export class RsMotionModule {}
